import React, { useState, useEffect } from 'react'
import { Box, InputGroup, Input, InputRightElement, IconButton, Flex, Button, useColorModeValue, Tooltip } from '@chakra-ui/react'
import { SearchIcon, RepeatIcon } from '@chakra-ui/icons'
import { useConferirTodosOsProdutos } from '../hooks/useConferirTodosOsProdutos'

export function FilterBar() {
  const bgColor = useColorModeValue('white', 'gray.800')
  const borderColor = useColorModeValue('gray.200', 'gray.700')
  const [localSearch, setLocalSearch] = useState('')

  const { setBusca, queryParams, refetch } = useConferirTodosOsProdutos()

  const handleInputChange = (e) => {
    setLocalSearch(e.target.value)
  }

  const handleSearch = () => {
    console.log('Executando busca com termo:', localSearch)
    setBusca(localSearch)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  useEffect(() => {
    setLocalSearch(queryParams.buscar || '')
  }, [queryParams.buscar])

  return (
    <Box p={4} borderRadius="md" bg={bgColor} borderWidth="1px" borderColor={borderColor} shadow="sm" width="100%">
      <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
        {/* Campo de busca */}
        <InputGroup flex={1}>
          <Input value={localSearch} placeholder="Buscar por nome ou código do produto..." onChange={handleInputChange} onKeyPress={handleKeyPress} />
          <InputRightElement>
            <IconButton aria-label="Buscar produtos" icon={<SearchIcon />} size="sm" onClick={handleSearch} variant="ghost" />
          </InputRightElement>
        </InputGroup>

        {/* Botão de atualizar */}
        <Tooltip label="Atualizar resultados">
          <Button leftIcon={<RepeatIcon />} colorScheme="blue" onClick={refetch} minWidth={{ base: '100%', md: '140px' }}>
            Atualizar
          </Button>
        </Tooltip>
      </Flex>
    </Box>
  )
}
